const COLORS = ["#16A34A", "#2563EB", "#0EA5E9", "#7C3AED", "#0A2540", "#059669", "#E11D48", "#F59E0B"];

function initials(name = "") {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "?";
}

function colorFor(name = "") {
  let sum = 0;
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
  return COLORS[sum % COLORS.length];
}

export function Avatar({ name, photo, size = 48, className = "" }) {
  const bg = colorFor(name);
  if (photo) {
    return <img src={photo} alt={name} style={{ width: size, height: size }} className={`rounded-full object-cover ${className}`} />;
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center font-display font-bold text-white shrink-0 ${className}`}
      style={{ width: size, height: size, background: bg, fontSize: size * 0.38 }}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
